"use client";
import { getSimpleTranslation } from "@/libs/translation/Translate";
import styles from "./terms.module.scss";
import {Fragment} from "react";
import { useSearchParams } from "next/navigation";
import Link from "next/link";

interface ITermsSection {
    type: "paragraph" | "numberList",
    content?: string;
    title?: string;
    isHtml?: boolean;
    list?: {
        content: string;
        isHtml?: boolean;
    }[];
}

export default function Terms() {
    const searchParams = useSearchParams();
    const lang = searchParams.get('lang') || 'hy';

    const sections: ITermsSection[] = [
        {
            type: 'paragraph',
            title: 'Սույն պայմաններում'
        },
        {
            type: "paragraph",
            isHtml: true,
            content: `
                <b>«Պայմաններ»</b> նշանակում է Հարթակից օգտվելու սույն պայմանները։
            `
        },
        {
            type: "paragraph",
            isHtml: true,
            content: `
                <b>«Մենք»</b> կամ <b>«Ընկերություն»</b> նշանակում է <b>«ՊՐԱԳՄԱՏԻԿՍ» սահմանափակ պատասխանատվությամբ
                ընկերություն</b> (ՀՀ օրենսդրությամբ սահմանված կարգով գրանցված և գործող ընկերություն,
                286.110.1113962, ՀՎՀՀ\` 02821853, իրավաբանական հասցեն՝ ՀՀ, ք. Երևան, Դեմիրճյան փ.,
                շ. 31, բն. 14),  որը հասանելի է դարձնում  Հարթակը  այն մանկապարտեզների աշխատողներին
                և այնտեղ հաճախող երեխաների ծնողներին, որոնց հետ կնքված է Հարթակի տրամադրման մասով
                ծառայությունների մատուցման պայմանագիր:
            `
        },
        {
            type: 'paragraph',
            isHtml: true,
            content: `
                <b>«Հարթակ»</b> նշանակում է «Baleek (Բալիկ)» բջջային հարթակ  և վեբ ադմինիստրատիվ պորտալ,
                որոնց միջոցով    մանկապարտեզներին  հնարավորություն է ընձեռվում իրականացնել ներքին
                կառավարում, իսկ դրանց աշխատողների և այնտեղ հաճախող  երեխաների ծնողներին՝
                տեղեկություններ փոխանակել միմյանց միջև։
            `
        },
        {
            type: 'paragraph',
            isHtml: true,
            content: `
                <b>«Աշխատող»</b>  նշանակում է Ընկերության հետ Հարթակի տրամադրման մասով ծառայությունների
                մատուցման պայմանագիր կնքած մանկապարտեզի աշխատող:
            `
        },
        {
            type: 'paragraph',
            isHtml: true,
            content: `
                <b>«Երեխա»</b>  նշանակում է  Ընկերության հետ Հարթակի տրամադրման մասով ծառայությունների
                մատուցման պայմանագիր կնքած մանկապարտեզում ներառված (մանկապարտեզ հաճախող) երեխա։
            `
        },
        {
            type: 'paragraph',
            isHtml: true,
            content: `
                <b>«Ծնող»</b>  նշանակում է Երեխայի ծնող։
            `
        },
        {
            type: 'paragraph',
            isHtml: true,
            content: `
                <b>«Դուք»</b> նշանակում է ցանկացած անձ, որն օգտագործում է Հարթակը։
            `
        },
        {
            type: 'paragraph',
            isHtml: true,
            content: `
                <b>«Պայմանագիր»</b> նշանակում է Ընկերության և մանկապարտեզի միջև Հարթակի տրամադրման
                մասով ծառայությունների մատուցման պայմանագիր։
            `
        },
        {
            type: 'paragraph',
            isHtml: true,
            content: `
                <b>«Կողմեր»</b> անվանվում են  Աշխատողները և Ծնողները միասին, որոնցից յուրաքանչյուրն
                առանձին անվանվում է նաև <b>«Կողմ»</b>:
            `
        },
        {
            type: 'numberList',
            list: [
                {
                    content: `
                        Սույն Պայմանները (ներառյալ Գաղտնիության Քաղաքականությունը, որը կազմում է սույն
                        Պայմանների անբաժանելի մասը) հանդիսանում են Ձեր և Մեր միջև պայմանագիրը՝
                        Հարթակի օգտագործման հետ կապված։
                    `
                },
                {
                    content: `
                        Եթե  համաձայն չեք սույն Պայմանների հետ, անհրաժեշտ է զերծ մնալ Հարթակի օգտագործումից։
                    `
                },
                {
                    content: `
                        Նախքան  Հարթակից օգտվելը Դուք պետք է այն ներբեռնեք և օգտահաշիվ ունենաք Հարթակում,
                        որը ստեղծվում է մանկապարտեզի կողմից\` տրամադրելով Ծնողի անունը, ազգանունը, հայրանունը,
                        մայրանունը, հասցեն, էլեկտրոնային մեյլի հասցեն, հեռախոսահամարը, ծննդյան ամսաթիվը,
                        աշխատավայրը, սեռը: Հարթակ մուտք գործելու համար անհրաժեշտ է մուտքագրել Ձեր հեռախոսահամարը,
                        որից հետո կստանաք SMS կոդ Ձեր հեռախոսահամարին, որը նույնպես անհրաժեշտ է մուտքագրել: Օգտագործելով
                        Հարթակը՝ Դուք տալիս եք Ձեր համաձայնությունը Ձեր անձնական տվյալների մշակմանը և ընդունում և
                        համաձայնում եք Գաղտնիության Քաղաքականության մեջ նշված պայմաններին:  Ձեզնից պահանջվում է տրամադրել
                        ամբողջական և ճշգրիտ անձնական տվյալներ և դրանք թարմացնել։ Մենք չենք ստուգում Ձեր տրամադրած
                        տեղեկության ճշգրտությունը:
                    `
                },
                {
                    content: `
                        Բացառապես Դուք եք պատասխանատու Ձեր հեռախոսահամարի և ստացված SMS կոդի գաղտնիությունը պահպանելու
                        և այլ անձանց հասանելի չդարձնելու համար: Մենք պատասխանատվություն չենք կրում որևէ հետևանքների համար,
                        որոնք կարող են առաջանալ՝ կապված այլ անձանց կողմից Ձեր օգտահաշվի օգտագործման հետ: Դուք լիովին
                        պատասխանատու եք բոլոր գործողությունների համար, որոնք տեղի են ունենում Հարթակ  Ձեր հեռախոսահամարի
                        և ստացված SMS կոդի օգտագործմամբ մուտք գործելով:
                    `
                },
                {
                    content: `
                        Մուտք գործելով Հարթակ և օգտագործելով այն՝ Դուք տալիս եք Ձեր համաձայնությունը Հարթակի կամ Ձեր
                        կողմից տրամադրված էլ․ փոստի հասցեի միջոցով ստանալու բոլոր անհրաժեշտ ծանուցումները և տեղեկությունները:
                    `
                },
                {
                    content: `
                        Հարթակի տրամադրման մասով ծառայությունների մատուցման պայմանագրի շրջանակներում՝ Հարթակը
                        Ձեզ հասանելի է դարձվում Մեր կողմից՝ որպես մանկապարտեզին մատուցվող ծառայությունների մաս։
                        Մենք Ձեզ որևէ ծառայություն չենք մատուցում, ու որևէ պարտավորություն չենք կրում Հարթակը
                        Ձեզ հասանելի դարձնելու մասով (այն Ձեզ հասանելի է դարձվում մանկապարտեզի կողմից
                            համապատասխան վճարման կատարման դեպքում):
                    `
                },
                {
                    content: `
                        Մենք վճար չենք գանձում Ձեզնից Հարթակի օգտագործման համար, և, հետևաբար, պարտավորություն
                        չունենք ապահովելու Հարթակի որևէ կոնկրետ կատարողական, որակ կամ առանձնահատկություններ:
                        Մենք բացառում ենք Մեր և Մեր գործակալների, անկախ կապալառուների, ինչպես նաև Մեր և նրանց
                        աշխատողների, պաշտոնյաների, գործակալների պատասխանատվությունը գործողությունների կամ
                        անգործությունների, սխալների, բացթողումների, ինչպես նաև Ձեր՝ Հարթակ մուտք գործելու
                        հետ կապված վնասների համար՝ անկախ այդպիսի պատասխանատվության իրավական հիմքից\`
                        այնքանով որքանով թույլատրվում է ՀՀ օրենսդրությամբ:
                    `
                },
                {
                    content: `
                        Մենք պատասխանատվություն չենք կրում Կողմերի կողմից տրամադրված տեղեկության անճշտության,
                        դրանց վերաբերյալ ցանկացած այլ տեղեկության ստուգման համար, ինչպես նաև Ձեր և այլ անձանց
                        միջև կնքված պայմանագրից բխող պարտավորությունների կատարման համար: Մենք պատասխանատվություն
                        չենք կրում Կողմերի գործողությունների/անգործության, սխալների, բացթողումների կամ նրանց
                        կողմից պատճառված վնասների համար: Մենք չենք երաշխավորում, որ Հարթակում առկա
                        բովանդակությունը ճշգրիտ, ամբողջական, հուսալի, թարմացված կամ առանց սխալների է:
                    `
                },
                {
                    content: `
                        Մենք կարող ենք կասեցնել ցանկացած Կողմի մուտքը Հարթակ՝ այլ Կողմի կողմից նրանց դեմ
                        ներկայացված բողոքների հիման վրա, նրանց կողմից սույն Պայմանների կամ նրանց հետ կնքված
                        որևէ պայմանագրի որևէ խախտման դեպքում:  Մենք կարող ենք կասեցնել ցանկացած Կողմի մուտքը
                        Հարթակ՝ մանկապարտեզի պահանջով։
                    `
                },
                {
                    content: `
                        Ձեր մուտքը և Հարթակի օգտագործումը կարող է ժամանակ առ ժամանակ ընդհատվել մի քանի պատճառով,
                        ներառյալ, առանց սահմանափակման՝ սարքավորումների անսարքությունը, Հարթակի պարբերական
                        թարմացումը, սպասարկումը կամ վերանորոգումը կամ այլ գործողություններ, որոնք Մենք կարող ենք
                        ձեռնարկել Մեր հայեցողությամբ։ Մենք ոչ մի դեպքում պատասխանատվություն չենք կրի Ձեր առջև որևէ
                        կորստի, ծախսի կամ վնասի համար, որը բխում է Հարթակի պլանավորված կամ չնախատեսված խափանումից:
                        Ավելին, Հարթակի օգտագործումը մեծապես կախված է ինտերնետ ցանցի աշխատանքից։ Համապատասխանաբար,
                        Մենք չենք կարող երաշխավորել Հարթակի հասանելիությունը ինտերնետ կապի հնարավոր անհասանելիության
                        կամ այդ ցանցի այլ խափանումների պատճառով: Մենք ձեռնարկում ենք ողջամիտ ջանքեր՝ ապահովելու
                        Հարթակի շարունակական և անխափան կատարումը: Այնուամենայնիվ, Մենք պատասխանատվություն չենք
                        կրում Հարթակի գործունեության ցանկացած ընդհատման համար, եթե դա պայմանավորված է երրորդ կողմերի
                        գործողություններով կամ ինտերնետի աշխատանքով: Մենք պատասխանատվություն չենք կրում նաև Հարթակի
                        աշխատանքի ցանկացած ընդհատման կամ Հարթակի հետ կապված որևէ այլ խնդրի համար, եթե դա համակարգչային
                        վիրուսի կամ այլ վնասակար ծրագրաշարի ազդեցության հետևանք է:
                    `
                },
                {
                    content: `
                        Հարթակը տրամադրվում է «ինչպես կա» և «ինչպես հասանելի է» հիմունքներով՝ առանց որևէ տեսակի
                        հստակ կամ ենթադրյալ ցուցումների կամ երաշխիքների, ներառյալ, բայց չսահմանափակվելով գործառնության,
                        մատչելիության, հասանելիության, ամբողջականության, ճշգրտության կամ ցանկացած նպատակով Հարթակի
                        համապատասխանության հետ կապված հավաստումները կամ երաշխիքները: Հարթակի օգտագործումից Ձեր համար
                        բխող ցանկացած ռիսկի համար լիովին և բացառապես պատասխանատու եք Դուք:
                    `
                },
                {
                    content: `
                        Դուք չպետք է որևէ կերպ օգտագործեք Հարթակը, եթե այն վնաս է պատճառում կամ կարող է վնասել
                        Հարթակի հուսալիությանը կամ հասանելիությանը: Դուք չպետք է օգտագործեք Հարթակը՝ պատճենելու,
                        պահպանելու, հրապարակում կատարելու, փոխանցելու, ուղարկելու, օգտագործելու, հրապարակելու
                        կամ տարածելու որևէ նյութ, որը պարունակում է  որևէ համակարգչային վիրուս կամ այլ վնասակար
                        համակարգչային ծրագրեր: Դուք չպետք է իրականացնեք որևէ համակարգված կամ ավտոմատացված
                        տվյալների հավաքագրման գործունեություն կամ դրանց առնչությամբ գործողություններ կատարեք
                        առանց Մեր հստակ գրավոր համաձայնության:
                    `
                },
                {
                    content: `
                        Հարթակի բովանդակությունը (տեղեկություններ, պատկերներ, տեսանյութեր և այլն) տրամադրվում է
                        Մեր կողմից: Հեղինակային իրավունքը և այլ մտավոր սեփականության իրավունքները Հարթակում և
                        դրա նկատմամբ պատկանում են Մեզ կամ Մեզ հետ համագործակցող կազմակերպություններին: Հարթակի
                        հանդեպ բոլոր իրավունքները պաշտպանված են, և Հարթակի բովանդակությունը չի կարող որևէ կերպ
                        փոփոխվել, տարածվել, ցուցադրվել որևէ ձևով կամ որևէ կերպ, ներառյալ, բայց չսահմանափակվելով
                        էլեկտրոնային, մեխանիկական միջոցներով, լուսանկարելով, ներբեռնելով կամ ձայնագրելով
                        առանց Մեր նախնական գրավոր թույլտվության:
                    `
                },
                {
                    content: `
                        Հարթակում առկա ապրանքային նշանները հանդիսանում են Մեր կամ Մեզ հետ համագործակցող
                        կազմակերպությունների մտավոր սեփականությունը, որի իրավական պաշտպանությունը նախատեսված է
                        ՀՀ օրենսդրությամբ և համապատասխան միջազգային պայմանագրերով:
                    `
                },
                {
                    content: `
                        Մենք որևէ պատասխանատվություն չենք կրում երրորդ կողմի բովանդակության համար (ներառյալ՝
                        Աշխատողներին, Ծնողներին, Երեխաներին վերաբերող ցանկացած տեղեկությունը), որը կարող է
                        հասանելի լինել Հարթակի միջոցով, ինչպես նաև Հարթակի հետ կապված բովանդակության համար:
                        Այն դեպքում, երբ Մենք հղում ենք կատարում երրորդ կողմի կայքերին/հավելվածներին,
                        Դուք մուտք եք գործում այդ հղումներով Ձեր սեփական ռիսկով: Մենք խորհուրդ ենք տալիս կարդալ
                        այս կայքերի/հավելվածների քաղաքականությունները:
                    `
                },
                {
                    content: `
                        Երբ Դուք մուտք եք գործում Հարթակ և (կամ) օգտագործում այն, Դուք հաստատում եք, որ կարդացել
                        և հասկացել եք այս Պայմանները և համաձայնում եք պահպանել դրանք:
                    `
                },
                {
                    content: `
                        Մենք իրավունք ունենք փոխել այս Պայմանները և այս Հարթակի նկատմամբ կիրառելի ցանկացած
                        քաղաքականություն:  Ձեզ այդ մասին լրացուցիչ կծանուցվի փոփոխությունների ուժի մեջ
                        մտնելուց հինգ օր առաջ Հարթակի կամ էլ․ փոստի միջոցով։ Այս փոփոխությունները ուժի
                        մեջ են մտնում Հարթակում դրանց տեղադրման օրվանից հինգ օր անց: Եթե Դուք շարունակեք
                        օգտվել այս Հարթակից, դա նշանակում է, որ Դուք ընդունել եք այս փոփոխությունները:
                    `
                },
                {
                    content: `
                        Մեր և Ձեր միջև ծագած որևէ վեճի դեպքում նման վեճերը ենթակա են կարգավորման Ձեր և
                        Մեր միջև ուղիղ բանակցությունների միջոցով 30-օրյա ժամկետում: Սահմանված ժամկետում
                        համաձայնություն ձեռք չբերելու դեպքում վեճերը ենթակա են Հայաստանի Հանրապետության
                        դատարանների բացառիկ իրավասությանը՝  Հայաստանի Հանրապետության օրենսդրությամբ սահմանված
                        կարգով: Ձեր և Մեր միջև պայմանավորվածության դեպքում վեճը կարող է ներկայացվել
                        հաշտարարության կամ արբիտրաժի:
                    `
                },
            ]  
        },
        {
            type: "paragraph",
            title: 'Կոնտակտային տեղեկատվություն',
            isHtml: true,
            content: `
                Սույն Պայմանների վերաբերյալ հարցերի առկայության պարագայում Մեզ հետ կարող եք կապ հաստատել էլ․
                փոստի միջոցով հետևյալ հասցեով՝ <a href="mailto:support@baleek.am">support@baleek.am</a>:
            `
        },
    ];

    const sectionsEn: ITermsSection[] = [
        {
            type: 'paragraph',
            title: 'In the present terms of use'
        },
        {
            type: "paragraph",
            isHtml: true,
            content: `
                <b>“Terms”</b> shall mean the present terms of use of the Platform.
            `
        },
        {
            type: "paragraph",
            isHtml: true,
            content: `
                <b>“We”</b> or <b>“Company”</b> shall mean PRAGMATIX limited liability company (registered and operating
                under the legislation of the Republic of Armenia, registration number: 286.110.1113962, TIN: 02821853,
                legal address: apt. 14, 31 Demirchyan str., Yerevan, Republic of Armenia), which makes the Platform available
                to kindergarten employees and parents of children attending the kindergarten, with whom a service provision
                agreement regarding the provision of the Platform has been concluded.
            `
        },
        {
            type: 'paragraph',
            isHtml: true,
            content: `
                <b>“Platform”</b> shall mean “Baleek” mobile platform and web administrative portal, which facilitates
                internal management for kindergartens and enables communication between their employees and parents of
                attending children.
            `
        },
        {
            type: 'paragraph',
            isHtml: true,
            content: `
                <b>“Employee”</b> shall mean an employee of a kindergarten that has signed a service provision agreement
                with the Company regarding the provision of the Platform.
            `
        },
        {
            type: 'paragraph',
            isHtml: true,
            content: `
                <b>“Child”</b> shall mean a child enrolled in (attending) a kindergarten that has entered into a service
                provision agreement with the Company regarding the provision of the Platform.
            `
        },
        {
            type: 'paragraph',
            isHtml: true,
            content: `
                <b>“Parent”</b> shall mean a Child’s parent.
            `
        },
        {
            type: 'paragraph',
            isHtml: true,
            content: `
                <b>“You”</b> shall mean any person using the Platform.
            `
        },
        {
            type: 'paragraph',
            isHtml: true,
            content: `
                <b>“Agreement”</b> shall mean the service provision agreement between the Company and the kindergarten
                regarding the provision of the Platform.
            `
        },
        {
            type: 'paragraph',
            isHtml: true,
            content: `
                <b>“Parties”</b> shall mean Employees and Parents jointly, each separately also referred to as the <b>“Party”</b>.
            `
        },
        {
            type: 'numberList',
            list: [
                {
                    content: `
                    These Terms (including the Privacy Policy, which forms an integral part of these Terms) constitute the agreement between You and Us in relation to the use of the Platform.
                    `
                },
                {
                    content: `
                    If you do not agree with these Terms, You should refrain from using the Platform.
                    `
                },
                {
                    content: `
                    Before using the Platform, You must download it and have an account on the Platform, which is created by the kindergarten, providing the Parent's name, surname, father’s name, mother’s name, address, email address, phone number, date of birth, place of work, gender. To log into the Platform, You need to enter Your phone number, after which You will receive an SMS code to Your phone number, which You also need to enter. By using the Platform, You consent to the processing of Your personal data and accept and agree to the terms set forth in the Privacy Policy. You are required to provide complete and accurate personal data and keep it updated. We do not verify the accuracy of the information You provide.
                    `
                },
                {
                    content: `
                    ou are solely responsible for maintaining the confidentiality of your phone number and received SMS code and not making it available to other people. We are not responsible for any consequences that may arise in connection with the use of Your account by other persons. You are fully responsible for all actions that occur when accessing the Platform using Your phone number and received SMS code.
                    `
                },
                {
                    content: `
                    By logging into and using the Platform, You give your consent to receive all required notices and information through the Platform or email address provided by You.
                    `
                },
                {
                    content: `
                    Within the framework of the service provision agreement regarding the provision of the Platform, the Platform is made available to You by Us as part of the services provided to the kindergarten. We do not provide You with any service, and We do not bear any obligation to make the Platform available to you (it is made available to You in case of making the appropriate payment by the kindergarten).
                    `
                },
                {
                    content: `
                    We do not charge You a fee for using the Platform and therefore have no obligation to ensure any particular performance, quality or features of the Platform. We exclude Our liability and that of Our agents and independent contractors, and Our and their employees, officers, agents for actions/inactions, errors, omissions as well as for damages relating to Your access to the Platform, whatever the legal basis of such liability would be, to the extent permitted by the law of the Republic of Armenia.
                    `
                },
                {
                    content: `
                    We are not responsible for the inaccuracy of the information provided by the Parties, for the verification of any other information regarding them, as well as for the fulfillment of the obligations arising from the contract concluded between You and other persons. We are not responsible for the actions/inactions, errors, omissions or damages caused by the Parties. We do not warrant that the content on the Platform is accurate, complete, reliable, up-to-date or error-free.
                    `
                },
                {
                    content: `
                    We may suspend any Party’s access to the Platform upon complaints made against them by another Party, as well as in the event of any breach by them of these Terms or of any agreement entered into with them. We may suspend any Party’s access to the Platform at the kindergarten's request.
                    `
                },
                {
                    content: `
                    Your access and use of the Platform may be interrupted from time to time for several reasons, including, without limitation, the malfunction of equipment, periodic updating, maintenance or repair of the Platform or other actions that We, in our sole discretion, may choose to take. In no event will We be liable to You for any loss, cost, or damage that results from any scheduled or unscheduled downtime. Moreover, the use of the Platform largely depends on the operation of the internet network. Accordingly, We cannot guarantee the availability of the Platform due to the possible unavailability of Internet connection or other failures of that network. We undertake reasonable efforts to ensure continuous and uninterrupted performance of the services. However, We are not responsible for any interruption of the operation of the Platform, if it is due to the actions of third parties or to the work of the Internet. We are also not responsible for any interruption of the operation of the Platform or any other problem associated with the Platform, if it is the consequence of the effect of a computer virus or other malicious software.
                    `
                },
                {
                    content: `
                    The Platform is provided on “as is” and “as available” basis without express or implied representations or warranties of any kind, including but not limited to representations or warranties related to the operation, accessibility, availability, completeness, accuracy or suitability of the Platform for any purpose. You are fully and solely responsible for any risk arising from Your use of the Platform.
                    `
                },
                {
                    content: `
                    You must not use the Platform in any way if it causes or may cause damage to the reliability or availability of the Platform. You must not use the Platform to copy, store, post, transmit, send, use, publish or distribute any material which consists of any computer virus or other malicious computer software. You must not conduct any systematic or automated data collection activities or acts in relation to them without Our express written consent.
                    `
                },
                {
                    content: `
                    The content (information, images, videos, etc.) of the Platform is provided by Us. Copyright and other intellectual property rights in and to the Platform belong to Us or to entities who cooperate with Us. All rights to the Platform are reserved, and the content of the Platform cannot be in any way modified, distributed, displayed in any manner or by any means, including but not limited to electronic, mechanical means, photographing, downloading, or recording without Our prior written permission.
                    `
                },
                {
                    content: `
                    The trademarks placed on the Platform constitute Our intellectual property of that of organizations cooperating with Us, the legal protection of which is provided by the legislation of the Republic of Armenia and relevant international treaties.
                    `
                },
                {
                    content: `
                    We do not assume any responsibility for third party content (including any information relating to Employees, Parents, Children) that may be available through the Platform, and for content linked to the Platform. Where We link to third party websites/applications, You use such websites/applications at your own risk. We recommend reading the policies of these websites/applications.
                    `
                },
                {
                    content: `
                    When You log into the Platform and/or use it, You confirm that You have read and understood these Terms and agree to abide by them.
                    `
                },
                {
                    content: `
                    We have the right to change these Terms and any policy applicable to this Platform. You will be additionally notified about it five days before the changes come into force on the Platform or by e-mail. These changes become effective five days after they are placed on the Platform. If you continue to use this Platform, it shall mean that you have accepted these changes.
                    `
                },
                {
                    content: `
                    In case of any disputes arisen between You and Us, such disputes shall be subject to settlement through direct negotiations between You and Us within a 30-day period. In case of failure to reach an agreement within the provided period the disputes shall be subject to the exclusive jurisdiction of the courts of the Republic of Armenia under the legislation of the Republic of Armenia. Upon the agreement between You and Us, the dispute may be submitted to mediation or arbitration.
                    `
                },
            ]  
        },
        {
            type: "paragraph",
            title: 'Contact Information',
            isHtml: true,
            content: `
                If You have any questions about these Terms, please feel free to contact Us by e-mail at <a href="mailto:support@baleek.am">support@baleek.am</a>.
            `
        },
    ]

    return (
        <section className={`${styles.terms}`}>
            <div className="container">
                <Link className="lang-switcher" href={`/terms/${lang === 'en' ? '' : '?lang=en'}`}>
                    {lang === 'en' ? "Armenian" : "English"}
                </Link>
                <h2 className={'text-center mb-5'}>{getSimpleTranslation("terms", {}, lang)}</h2>
                {(lang === 'en' ? sectionsEn : sections).map((s, index) => <Fragment key={index}>{getSectionByType(s)}</Fragment>)}
                <p className={'fw-bold'}>{getSimpleTranslation("updatedOn", {date: "27/03/2024"}, lang)}</p>
            </div>
        </section>
    );

    function getSectionByType(section: ITermsSection) {
        switch (section.type) {
            case "paragraph":
                return (
                    <>
                        {section.title && <h5 className={'mb-1'}>{section.title}</h5>}
                        <p {...(section.isHtml && section.content ? {dangerouslySetInnerHTML: {__html: section.content}} : {})}>
                            {section.isHtml ? null : section.content}
                        </p>
                    </>
                );
            case "numberList":
                return (
                    <ol className={'ps-3'}>
                        {
                            section?.list?.map((i, index) => (
                                <li key={index} className={'mb-2'}
                                    {...(i.isHtml ? {dangerouslySetInnerHTML: {__html: i.content}} : {})}
                                >
                                    {i.isHtml ? null : i.content}
                                </li>
                            ))
                        }
                    </ol>
                )
        }
    }
}
